import { useTranslation } from "react-i18next";
import { Sheet, SheetContent, SheetTitle } from "../ui/sheet";
import NotificationsList from "./NotificationsList";

interface Props {
  open: boolean;
  onOpenChange(open: boolean): void;
}

/**
 * The bell's panel: the notification list in a sheet at most half the viewport tall, with an X
 * top right. Full width from the top on mobile; on desktop a card next to the side nav.
 */
export default function NotificationsPanel({ open, onOpenChange }: Props) {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="top"
        data-testid="notifications-panel"
        aria-describedby={undefined}
        overlayClassName="z-[2050]"
        className="z-[2050] bg-[var(--bg-base)] md:left-[64px] md:right-auto md:top-2 md:w-[min(420px,calc(100vw-80px))] md:rounded-xl"
      >
        {open && (
          <NotificationsList
            reserveCloseSpace
            onNavigate={() => onOpenChange(false)}
            title={<SheetTitle>{t("notifications")}</SheetTitle>}
          />
        )}
      </SheetContent>
    </Sheet>
  );
}
